import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'maskedtext'
})
export class MaskedtextPipe implements PipeTransform {

  transform(value: string): string {
    if (!value) return '';

    // EMAIL MASKING
    if (value.includes('@')) {
      const [user, domain] = value.split('@');

      if (user.length <= 2) {
        return user[0] + '****@' + domain;
      }

      const first = user.slice(0, 2);
      const last = user.slice(-1);

      return `${first}****${last}@${domain}`;
    }

    // MOBILE NUMBER MASKING
    const digits = value.replace(/\D/g, ''); // Remove non-numeric chars

    if (digits.length < 4) return value;

    const firstTwo = digits.slice(0, 2);
    const lastTwo = digits.slice(-2);

    return `(${firstTwo}*) *****${lastTwo}`;
  }
}
